import React from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { ToastContainer } from "../toast/ToastContainer";
import { FloatingUrlBar } from "../urlbar/FloatingUrlBar";

export const AppShell: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const location = useLocation();
  const isAuthPage = ["/login", "/register", "/forgot-password", "/confirm-email"].includes(location.pathname);

  return (
    <div className="ob-app-root">
      {!isAuthPage && <Navbar />}
      <main className="ob-app-main">{children}</main>
      <FloatingUrlBar />
      <ToastContainer />
    </div>
  );
};

